enum SkillType {
  HARD_SKILLS = 'HARD_SKILLS',
  FRAMEWORKS_OR_METHODOLOGIES = 'FRAMEWORKS_OR_METHODOLOGIES',
  BUSINESS_EXPERIENCE = 'BUSINESS_EXPERIENCE',
  CERTIFICATIONS = 'CERTIFICATIONS'
}
export default SkillType;
